import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { EndpointDetailsWebComponentSchema } from '../types';

export class EndpointDetailsBaseDataProvider extends BaseWebComponentDataProvider {
  async getEndpointDetails(endpointId): Promise<EndpointDetailsWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
